import type { ComponentType, SVGProps } from "react";

import AntDesignSvg from "./icons/antdesign.svg";
import AppwriteSvg from "./icons/appwrite.svg";
import AwsSvg from "./icons/aws.svg";
import ChromeWebStoreSvg from "./icons/chromewebstore.svg";
import ClaudeSvg from "./icons/claude.svg";
import ClerkSvg from "./icons/clerk.svg";
import CopilotSvg from "./icons/copilot.svg";
import Css3Svg from "./icons/css3.svg";
import CursorSvg from "./icons/cursor.svg";
import DockerSvg from "./icons/docker.svg";
import ExpressjsSvg from "./icons/expressjs.svg";
import FirebaseSvg from "./icons/firebase.svg";
import FormikSvg from "./icons/formik.svg";
import GeminiSvg from "./icons/gemini.svg";
import HerouiSvg from "./icons/heroui.svg";
import Html5Svg from "./icons/html5.svg";
import JavaSvg from "./icons/java.svg";
import JavascriptSvg from "./icons/javascript.svg";
import MinioSvg from "./icons/minio.svg";
import MongodbSvg from "./icons/mongodb.svg";
import MuiSvg from "./icons/mui.svg";
import MysqlSvg from "./icons/mysql.svg";
import NextjsSvg from "./icons/nextjs.svg";
import NodejsSvg from "./icons/nodejs.svg";
import NpmSvg from "./icons/npm.svg";
import OllamaSvg from "./icons/ollama.svg";
import OpenAISvg from "./icons/openai.svg";
import PlaywrightSvg from "./icons/playwright.svg";
import PnpmSvg from "./icons/pnpm.svg";
import PostgresqlSvg from "./icons/postgresql.svg";
import PostmanSvg from "./icons/postman.svg";
import PrismaSvg from "./icons/prisma.svg";
import RadixuiSvg from "./icons/radixui.svg";
import RazorpaySvg from "./icons/razorpay.svg";
import ReactjsSvg from "./icons/reactjs.svg";
import ReacthookformSvg from "./icons/reacthookform.svg";
import ReactquerySvg from "./icons/reactquery.svg";
import ReactrouterSvg from "./icons/reactrouter.svg";
import ReacttableSvg from "./icons/reacttable.svg";
import ReduxSvg from "./icons/redux.svg";
import ShadcnuiSvg from "./icons/shadcnui.svg";
import SpringbootSvg from "./icons/springboot.svg";
import StripeSvg from "./icons/stripe.svg";
import SupabaseSvg from "./icons/supabase.svg";
import SwrSvg from "./icons/swr.svg";
import TailwindcssSvg from "./icons/tailwindcss.svg";
import TypescriptSvg from "./icons/typescript.svg";
import VercelSvg from "./icons/vercel.svg";
import VimeoSvg from "./icons/vimeo.svg";
import ViteSvg from "./icons/vite.svg";
import WebpackSvg from "./icons/webpack.svg";
import YupSvg from "./icons/yup.svg";
import ZodSvg from "./icons/zod.svg";
import ZustandSvg from "./icons/zustand.svg";

import GithubSvg from "./icons/github.svg";
import LinkedInSvg from "./icons/linkedin.svg";
import resumeSvg from "./icons/resume.svg";
import TopmateSvg from "./icons/topmate.svg";

export const AntDesign: ComponentType<SVGProps<SVGSVGElement>> = AntDesignSvg;
export const Appwrite: ComponentType<SVGProps<SVGSVGElement>> = AppwriteSvg;
export const AWS: ComponentType<SVGProps<SVGSVGElement>> = AwsSvg;
export const ChromeWebStore: ComponentType<SVGProps<SVGSVGElement>> = ChromeWebStoreSvg;
export const Claude: ComponentType<SVGProps<SVGSVGElement>> = ClaudeSvg;
export const Clerk: ComponentType<SVGProps<SVGSVGElement>> = ClerkSvg;
export const Copilot: ComponentType<SVGProps<SVGSVGElement>> = CopilotSvg;
export const CSS3: ComponentType<SVGProps<SVGSVGElement>> = Css3Svg;
export const Cursor: ComponentType<SVGProps<SVGSVGElement>> = CursorSvg;
export const Docker: ComponentType<SVGProps<SVGSVGElement>> = DockerSvg;
export const ExpressJS: ComponentType<SVGProps<SVGSVGElement>> = ExpressjsSvg;
export const Firebase: ComponentType<SVGProps<SVGSVGElement>> = FirebaseSvg;
export const Formik: ComponentType<SVGProps<SVGSVGElement>> = FormikSvg;
export const Gemini: ComponentType<SVGProps<SVGSVGElement>> = GeminiSvg;
export const HeroUI: ComponentType<SVGProps<SVGSVGElement>> = HerouiSvg;
export const HTML5: ComponentType<SVGProps<SVGSVGElement>> = Html5Svg;
export const Java: ComponentType<SVGProps<SVGSVGElement>> = JavaSvg;
export const JavaScript: ComponentType<SVGProps<SVGSVGElement>> = JavascriptSvg;
export const Minio: ComponentType<SVGProps<SVGSVGElement>> = MinioSvg;
export const MongoDB: ComponentType<SVGProps<SVGSVGElement>> = MongodbSvg;
export const MUI: ComponentType<SVGProps<SVGSVGElement>> = MuiSvg;
export const MySQL: ComponentType<SVGProps<SVGSVGElement>> = MysqlSvg;
export const NextJS: ComponentType<SVGProps<SVGSVGElement>> = NextjsSvg;
export const NodeJS: ComponentType<SVGProps<SVGSVGElement>> = NodejsSvg;
export const NPM: ComponentType<SVGProps<SVGSVGElement>> = NpmSvg;
export const Ollama: ComponentType<SVGProps<SVGSVGElement>> = OllamaSvg;
export const OpenAI: ComponentType<SVGProps<SVGSVGElement>> = OpenAISvg;
export const Playwright: ComponentType<SVGProps<SVGSVGElement>> = PlaywrightSvg;
export const PNPM: ComponentType<SVGProps<SVGSVGElement>> = PnpmSvg;
export const Postman: ComponentType<SVGProps<SVGSVGElement>> = PostmanSvg;
export const PostgreSQL: ComponentType<SVGProps<SVGSVGElement>> = PostgresqlSvg;
export const Prisma: ComponentType<SVGProps<SVGSVGElement>> = PrismaSvg;
export const RadixUI: ComponentType<SVGProps<SVGSVGElement>> = RadixuiSvg;
export const Razorpay: ComponentType<SVGProps<SVGSVGElement>> = RazorpaySvg;
export const ReactJS: ComponentType<SVGProps<SVGSVGElement>> = ReactjsSvg;
export const ReactHookForm: ComponentType<SVGProps<SVGSVGElement>> = ReacthookformSvg;
export const ReactQuery: ComponentType<SVGProps<SVGSVGElement>> = ReactquerySvg;
export const ReactRouter: ComponentType<SVGProps<SVGSVGElement>> = ReactrouterSvg;
export const ReactTable: ComponentType<SVGProps<SVGSVGElement>> = ReacttableSvg;
export const Redux: ComponentType<SVGProps<SVGSVGElement>> = ReduxSvg;
export const ShadcnUI: ComponentType<SVGProps<SVGSVGElement>> = ShadcnuiSvg;
export const SpringBoot: ComponentType<SVGProps<SVGSVGElement>> = SpringbootSvg;
export const Stripe: ComponentType<SVGProps<SVGSVGElement>> = StripeSvg;
export const Supabase: ComponentType<SVGProps<SVGSVGElement>> = SupabaseSvg;
export const SWR: ComponentType<SVGProps<SVGSVGElement>> = SwrSvg;
export const TailwindCSS: ComponentType<SVGProps<SVGSVGElement>> = TailwindcssSvg;
export const TypeScript: ComponentType<SVGProps<SVGSVGElement>> = TypescriptSvg;
export const Vercel: ComponentType<SVGProps<SVGSVGElement>> = VercelSvg;
export const Vimeo: ComponentType<SVGProps<SVGSVGElement>> = VimeoSvg;
export const Vite: ComponentType<SVGProps<SVGSVGElement>> = ViteSvg;
export const Webpack: ComponentType<SVGProps<SVGSVGElement>> = WebpackSvg;
export const Yup: ComponentType<SVGProps<SVGSVGElement>> = YupSvg;
export const Zod: ComponentType<SVGProps<SVGSVGElement>> = ZodSvg;
export const Zustand: ComponentType<SVGProps<SVGSVGElement>> = ZustandSvg;

export const Github: ComponentType<SVGProps<SVGSVGElement>> = GithubSvg;
export const LinkedIn: ComponentType<SVGProps<SVGSVGElement>> = LinkedInSvg;
export const Resume: ComponentType<SVGProps<SVGSVGElement>> = resumeSvg;
export const Topmate: ComponentType<SVGProps<SVGSVGElement>> = TopmateSvg;
